import EthicsPage from "components/Texts/EthicsPage"

import { getGiftCardProperLanguagePolicy, InfoPageModel } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import { GetStaticProps } from "next"

type EthicsStaticProps = {
  data: InfoPageModel
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<EthicsStaticProps> = async () => {
  const { data } = await getGiftCardProperLanguagePolicy()

  const seo = {
    title: data?.body?.pageTitle,
    description: data?.body?.metaDescription,
    keywords: data?.body?.keywords,
  }
  return {
    props: { data: data?.body, seo },
    revalidate: 60,
  }
}
const Ethics = ({ data, seo }: EthicsStaticProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <EthicsPage data={data} />
    </>
  )
}

export default Ethics
